module.exports = __webpack_public_path__ + "static/dcom1-300x266-eeef2fa103ab42fa6343610a1953a5aa.png";